<template>
  <div id="app" class="">

    <router-view :key="$route.fullPath"></router-view>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  @import './assets/k6styles/general.scss';
  @import './assets/k6styles/toasts.scss';
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');

  /**
  * Don't use poppins font on icons and excercises (latex problems)
  */
  *:not(i, .fa, .glyphicon, .exerciseBox .box-body *) {
    font-family: 'Poppins', sans-serif !important;
  }

  #appe {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 50px;*/
    margin: 50px auto;
    max-width: 55em;
    background-color: #F7F7F7;
  }
  #app2 {
    /*margin-top: 50px;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.004);
    /*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;*/
    /*font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;*/
  }
</style>



// WEBPACK FOOTER //
// index.vue?5beb522a